import { Address } from "./address.model"
import { MerchantConfiguration } from './merchant-configuration.model'
import { Link } from "./link.model"

export class Merchant {
	name: string
	phone: string
	mobile: string
	fax: string
	email: string
	website: string
	merchantId: string
	legalEntityAddress: Address
	postalAddress: Address
	merchantConfiguration: MerchantConfiguration
	_links: {
		self: Link,
		bookingOffices: Link,
	}
}


// WEBPACK FOOTER //
// ./src/app/models/merchant.model.ts